import React from "react";
import { useGetImageById } from "../../../../api/queries";
import Spinner from "../../../../componentLibrary/Spinner";

export default function ImageComponent({
  imageId,
  width = 100,
  hasBorder = false,
}: {
  imageId: string;
  width?: number;
  hasBorder?: boolean;
}) {
  const { data: image, isError, isLoading } = useGetImageById(imageId);

  if (isError || isLoading) return <Spinner className="mx-auto" />;

  const getWidthClass = (width: number): string => {
    switch (width) {
      case 20:
        return "w-1/5";
      case 40:
        return "w-2/5";
      case 60:
        return "w-3/5";
      case 80:
        return "w-4/5";
      case 100:
        return "w-full";
      default:
        return "w-full";
    }
  };

  return (
    <div className="flex justify-center items-center">
      <img
        className={`${getWidthClass(width)} ${hasBorder ? "border-2 border-electrum-50 rounded-md shadow-md shadow-gray-400" : ""}`}
        src={image?.src}
        alt={image?.alt}
        referrerPolicy="strict-origin-when-cross-origin"
      />
    </div>
  );
}
